import axios from './../../config/axios';

function create(data) {
    return axios().post(`/stock-journal/stock-transfer-receipts`, data);
}

function find(id) {
    return axios().get(`/stock-journal/stock-transfer-receipts/${id}`);
}

function remove(id) {
    return axios().delete(`/stock-journal/stock-transfer-receipts/${id}`);
}

function update(data) {
    return axios().put(`/stock-journal/stock-transfer-receipts/${data.id}`, data);
}

function index(params) {
    params.limit = params.itemsPerPage;
    params.offset = (params.page - 1) * params.limit;
    return axios().get(`/stock-journal/stock-transfer-receipts`, {
        params
    });
}

function print(id) {
    console.log(id)
    return new Promise(resolve => {
        setTimeout(() => {
            resolve({
                data: `
                    <html>
                        <body>
                            <h1>Stock Transfer Receipt Print Page</h1>
                        </body>
                    </html>
                ` 
            })
        }, 300)
    })
}

function post(id) {
    return axios().put(`/stock-journal/stock-transfer-receipts/${id}/post`, {})
}

export default {
    create,
    find,
    remove,
    update,
    index,
    print,
    post
}